<button class="{{ hoverClass }}">
  <svg
    width="2048"
    height="2048"
    viewBox="0 0 2048 2048"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M1824 512c26.666 0 49.334 9.333 68 28s28 41.333 28 68v1216c0 26.667-9.334 49.333-28 68s-41.334 28-68 28H864c-26.667 0-49.333-9.333-68-28s-28-41.333-28-68v-288H224c-26.667 0-49.333-9.333-68-28s-28-41.333-28-68V768c0-26.667 6.667-56 20-88s29.333-57.333 48-76l408-408c18.667-18.667 44-34.667 76-48s61.333-20 88-20h416c26.667 0 49.333 9.333 68 28s28 41.333 28 68v328c45.333-26.667 88-40 128-40h416zm-544 213l-299 299h299V725zM640 341L341 640h299V341zm196 647l316-316V256H768v416c0 26.667-9.333 49.333-28 68s-41.333 28-68 28H256v640h512v-256c0-26.667 6.667-56 20-88s29.333-57.333 48-76zm956 804V640h-384v416c0 26.667-9.333 49.333-28 68s-41.333 28-68 28H896v640h896z"
      />
    </g>
  </svg>
</button>
